import { render, staticRenderFns } from "./client-list-page.vue?vue&type=template&id=8f9bedd6&scoped=true&"
import script from "./client-list-page.vue?vue&type=script&lang=js&"
export * from "./client-list-page.vue?vue&type=script&lang=js&"
import style0 from "./client-list-page.vue?vue&type=style&index=0&id=8f9bedd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9bedd6",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl})
